import { Context } from "@faire/deprecated-retailer-visitor-shared/components/LayoutElementRenderer/__internal__/Context";
import { Action } from "@faire/slate/foundation/color";
import * as React from "react";
import styled, { css } from "styled-components";

interface IProps {
  children?: React.ReactNode | undefined;
  className?: string;
}

export const Container: React.FC<IProps> = (props) => {
  const { layoutElement } = React.useContext(Context);
  return (
    <ContainerWrapper
      $backgroundColor={layoutElement.background_color}
      $textColor={layoutElement.main_text_color}
      className={props.className}
    >
      {props.children}
    </ContainerWrapper>
  );
};

const ContainerWrapper = styled.div<{
  $backgroundColor?: string;
  $textColor?: string;
}>`
  ${({ $backgroundColor, $textColor }) => css`
    background-color: ${$backgroundColor ?? "transparent"};
    color: ${$textColor ?? Action.text.active};
  `}
`;
